import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './exit-dialog.component.html'
})
export class ExitDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ExitDialogComponent>,
  ) {}

  doConfirm() {
    this.dialogRef.close(true);
  }
}
